<template>
  <div
    v-show="show"
    class="dt-gotop"
  >
    <div
      class="dt-gotop-arrow"
      @click="go2top"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    const self = this;
    const html = document.documentElement;
    const { body } = document;
    window.addEventListener('scroll', () => {
      const scrollTop = html.scrollTop || body.scrollTop;
      if (scrollTop > 200) {
        self.show = true;
      } else {
        self.show = false;
      }
    });
  },
  methods: {
    go2top() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scrop lang="scss">
.dt-gotop {
  position: fixed;
  right: 14px;
  bottom: 53px;
  z-index: 10;
}
.dt-gotop-adv img {
  width: 40px;
  height: 40px;
  border-radius: 3px;
  position: fixed;
  right: 14px;
  bottom: 108px;
  z-index: 10;
}

.dt-gotop-arrow {
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 3px;
  &:before {
    content: '';
    display: block;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    top: 5px;
    width: 12px;
    height: 12px;
    transform: rotate(-45deg);
    -ms-transform: rotate(-45deg); /* IE 9 */
    -moz-transform: rotate(-45deg); /* Firefox */
    -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
    -o-transform: rotate(-45deg); /* Opera */
    border-top: 2px solid #fff;
    border-right: 2px solid #fff;
  }
}
</style>
